import Typography from '@/components/Typography/Typography';
export default Typography;
